import { MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { FeeArrangementDTO, getAllFeeArrangementsForClient } from 'wisestep-api';
import { WsSelect } from 'wisestep-base';

interface IControlledWsSelectProps {
  name: string;
  label: string;
  clientId?: string;
  companyName?: string;
  variant?: 'outlined' | 'filled' | 'standard';
  showMandatorySymbol?: boolean;
  openDialogCallBack?: () => void;
  isFeeArrangementAdded?: boolean;
  jobType: string;
}

const CREATE_OPTION_VALUE = 'ADD_OPTION';
const allowedContractTypes = [
  'Contract',
  'Temporary',
  'Internship',
  'Freelance',
  'ContractToHireW2',
  'ContractW2',
  'ContractIndependent',
  'ContractToHireIndependent',
  'ContractCorpToCorp',
  'ContractToHireCorpToCorp',
  'PartTime',
  'FixedTermContract',
];
const getTargetContractType = (type) =>
  allowedContractTypes.some((allowedType) => allowedType.toLowerCase() === type?.toLowerCase())
    ? 'Contract'
    : type;

const FeeArrangementSelect = ({
  name,
  label,
  clientId,
  companyName,
  variant = 'outlined',
  showMandatorySymbol,
  openDialogCallBack,
  isFeeArrangementAdded,
  jobType,
}: IControlledWsSelectProps) => {
  const [list, setlist] = useState<any>([]);
  const { setValue, trigger } = useFormContext();
  const [keyUpdate, setKeyUpdate] = useState<number>(0);

  useEffect(() => {
    const getoptions = async () => {
      if (clientId && companyName) {
        const res = await getAllFeeArrangementsForClient(clientId);
        const arr =
          (res.data || [])
            ?.filter(
              (i: FeeArrangementDTO) =>
                getTargetContractType(i.contractType).toLowerCase() == jobType.toLowerCase() &&
                (!i.isArchive || i.isArchive === null)
            )
            ?.map((i: FeeArrangementDTO) => ({
              label: i.feeArrangementLevel,
              value: i.id,
            })) ?? [];
        setlist(arr);
      } else {
        setlist([]);
      }
    };
    getoptions();
  }, [clientId, companyName, isFeeArrangementAdded, jobType]);

  const handleOptionClick = async () => {
    await trigger(name);
    setValue(name, '');
    setKeyUpdate((prev) => prev + 1);
    openDialogCallBack ? openDialogCallBack() : null;
  };

  const CustomOption = () => (
    <MenuItem
      sx={{ color: 'primary.main' }}
      key={CREATE_OPTION_VALUE}
      value={CREATE_OPTION_VALUE}
      onClick={handleOptionClick}
    >
      {<>+ Add {label}</>}
    </MenuItem>
  );

  return (
    <WsSelect
      key={keyUpdate}
      name={name}
      label={label}
      selectArray={list}
      variant={variant}
      showMandatorySymbol={showMandatorySymbol}
      customOption={clientId && companyName && <CustomOption />}
    />
  );
};

export default FeeArrangementSelect;
